import React, { ReactNode } from "react";

const ConditionalButton = ({
  className,
  classNameLoading,
  onClick,
  isLoading,
  whenLoading,

  children,
  type,
}: {
  isLoading: boolean;
  whenLoading: React.ReactNode;
  className: string;
  classNameLoading: string;
  children: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  type?: "button" | "submit" | "reset";
}) => {
  return (
    <button
      type={type}
      className={isLoading ? classNameLoading : className}
      disabled={isLoading}
      onClick={onClick ?? undefined}
    >
      {isLoading ? whenLoading : children}
    </button>
  );
};
export default ConditionalButton;
